import request from '@/utils/request'

//登录接口
export const login = (data) => {
    return request({
        url: '/auth/login',
        method: 'post',
        data
    })
}

//快捷注册接口新增客户
export const register = (data) => {
    return request({
        url: '/hqprotal/information',
        method: 'post',
        data
    })
}

//退出登录接口
export const logoout = () => {
    return request({
        url: '/auth/logout',
        method: 'DELETE',
    })
}

//查询用户名是否相同
export const selectUserName = (data) => {
    return request({
        url: `/hqprotal/information/selectUserName?userName=${data}`,
        method: 'get',
    })
}

//邮箱发送验证码
export const sendCode = (params) => {
    return request({
        url: `/hqprotal/sendEmail/sendCode`,
        method: 'get',
        params
    })
}

//忘记密码
export const forgetPassword = (params) => {
    return request({
        url: `/system/user/forgetPassword`,
        method: 'get',
        params
    })
}

//忘记密码发送验证码
export const sendCode1 = (data) => {
    return request({
        url: `/system/user/sendCode/${data.email}`,
        method: 'get',
    })
}

//忘记密码修改密码
export const changePassword = (params) => {
    return request({
        url: `/system/user/changePassword`,
        method: 'get',
        params
    })
}

//工厂注册
export const regFactory = (data) => {
    return request({
        url: '/hqprotal/manage/newPlant',
        method: 'post',
        data
    })
}

//查询手机号是否相同
export const selectPhonenumer = (data) => {
    return request({
        url: `/system/user/selectPhonenumer?phonenumber=${data}`,
        method: 'get',
    })
}
